import { codiceMunicipio } from 'types/codiceMunicipio';

export const imageTitle = 'INCONTRACI\r\nNEGLI SPAZI WeMi';

export const imageDescription = `
  Gli spazi WeMi sono punto di incontro e orientamento nei quali, 
  grazie a operatori specializzati, trovare le soluzioni di welfare 
  più adatte ai tuoi bisogni e a quelli della tua famiglia, fruire 
  dei servizi WeMi, attivare forme di Welfare condiviso e sviluppare 
  azioni di volontariato.
`;

export const MIN_ADDRESS_CHARS = 3;

export const RESULT_LIMIT_MUNICIPALITY = 30;


export const MUNICIPALITIES_MAP = [
  [
    { dotColor: 'transparent' },
    { dotColor: 'transparent' },
    { dotColor: 'black' },
    { dotColor: 'transparent' },
    { dotColor: 'darkGrey', municipalityID: codiceMunicipio.MUNICIPIO_9 },
    { dotColor: 'black' },
    { dotColor: 'black' },
    { dotColor: 'transparent' },
  ],
  [
    { dotColor: 'black' },
    { dotColor: 'black' },
    { dotColor: 'darkGrey', municipalityID: codiceMunicipio.MUNICIPIO_8 },
    { dotColor: 'black' },
    { dotColor: 'black' },
    { dotColor: 'black' },
    { dotColor: 'darkGrey', municipalityID: codiceMunicipio.MUNICIPIO_2 },
    { dotColor: 'black' },
  ],
  [
    { dotColor: 'transparent' },
    { dotColor: 'black' },
    { dotColor: 'black' },
    { dotColor: 'black' },
    { dotColor: 'black' },
    { dotColor: 'black' },
    { dotColor: 'black' },
    { dotColor: 'darkGrey', municipalityID: codiceMunicipio.MUNICIPIO_3 },
  ],
  [
    { dotColor: 'black' },
    { dotColor: 'darkGrey', municipalityID: codiceMunicipio.MUNICIPIO_7 },
    { dotColor: 'black' },
    { dotColor: 'black' },
    { dotColor: 'darkGrey', municipalityID: codiceMunicipio.MUNICIPIO_1 },
    { dotColor: 'black' },
    { dotColor: 'black' },
    { dotColor: 'black' },
  ],
  [
    { dotColor: 'black' },
    { dotColor: 'transparent' },
    { dotColor: 'black' },
    { dotColor: 'darkGrey', municipalityID: codiceMunicipio.MUNICIPIO_6 },
    { dotColor: 'black' },
    { dotColor: 'black' },
    { dotColor: 'darkGrey', municipalityID: codiceMunicipio.MUNICIPIO_4 },
    { dotColor: 'black' },
  ],
  [
    { dotColor: 'transparent' },
    { dotColor: 'transparent' },
    { dotColor: 'transparent' },
    { dotColor: 'black' },
    { dotColor: 'black' },
    { dotColor: 'darkGrey', municipalityID: codiceMunicipio.MUNICIPIO_5 },
    { dotColor: 'black' },
    { dotColor: 'transparent' },
  ],
  [
    { dotColor: 'transparent' },
    { dotColor: 'transparent' },
    { dotColor: 'transparent' },
    { dotColor: 'transparent' },
    { dotColor: 'black' },
    { dotColor: 'black' },
    { dotColor: 'transparent' },
    { dotColor: 'transparent' },
  ],
];
